export default __webpack_public_path__ + "static/media/ISEO_CLASS-5_SYLLABUS_2025-26.f785bd05.pdf";